<template>
  <div class="main">
    <div class="banner" :style=" 'background-image: url(' + this.banner + ');'">
      <p class="bannerp1">{{bannertext1}}</p>
    </div>
    <div class="service">
      <div class="service1">
        <div class="service1r service1r1">
          <img :src="this.servicearray.operate_image" alt />
        </div>
        <div class="service1l">
          <p class="servicep">{{service1}}</p>
          <div class="servicesp1">{{this.strs1[0]}}</div>
          <div class="servicesp2">{{this.strs1[1]}}</div>
        </div>
      </div>
      <div class="service1">
        <div class="service1r service1r2">
          <img :src="this.servicearray.management_image" alt />
        </div>
        <div class="service1l">
          <p class="servicep">{{service2}}</p>
          <div class="servicesp1">{{this.strs2[0]}}</div>
          <div class="servicesp2">{{this.strs2[1]}}</div>
        </div>
      </div>
      <div class="service1">
        <div class="service1r service1r3">
          <img :src="this.servicearray.source_image" alt />
        </div>
        <div class="service1l">
          <p class="servicep">{{service3}}</p>
          <div class="servicesp1">{{this.strs3[0]}}</div>
          <div class="servicesp2">{{this.strs3[1]}}</div>
        </div>
      </div>
      <div class="service1">
        <div class="service1r service1r4">
          <img :src="this.servicearray.logistics_image" alt />
        </div>
        <div class="service1l">
          <p class="servicep">{{service4}}</p>
          <div class="servicesp1">{{this.strs4[0]}}</div>
          <div class="servicesp2">{{this.strs4[1]}}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      ischinese: "cn",
      bannertext1: "我们的服务",
      service1: "品牌代运管理",
      service2: "多模式渠道管理",
      service3: "供应链管理",
      service4: "数据管理",
      banner: "",
      strs1: [],
      strs2: [],
      strs3: [],
      strs4: [],
      servicearray: {
        operate_image: ""
      }
    };
  },
  methods: {},
  created() {
    this.ischinese = window.localStorage.getItem("ischinese") || "cn";
    if (this.ischinese == "en") {
      this.bannertext1 = "Our Service";
      this.service1 = "Brand Transportation Management";
      this.service2 = "Multi-mode Channel Management";
      this.service3 = "Supply Chain Management";
      this.service4 = "Data Management";
    }
    this.$http
      .post("/api/dashu/service/serviceList", {})
      .then(res => {
        // console.log(res.data.data)
        var code = res.data.code;
        if (code === 0) {
          if (this.ischinese == "cn") {
            this.banner = res.data.data.banner.mobile_img;
            this.servicearray = res.data.data.lists;
            // console.log(this.banner)
            var str1 = res.data.data.lists.operate;
            var strs1 = str1.split("\n");
            this.strs1 = strs1;

            var str2 = res.data.data.lists.management;
            var strs2 = str2.split("\n");
            this.strs2 = strs2;

            var str3 = res.data.data.lists.source;
            var strs3 = str3.split("\n");
            this.strs3 = strs3;

            var str4 = res.data.data.lists.logistics;
            var strs4 = str4.split("\n");
            this.strs4 = strs4;
          } else if (this.ischinese == "en") {
            this.banner = res.data.data.banner.mobile_img;
            this.servicearray = res.data.data.lists;
            // console.log(this.banner)
            var str1 = res.data.data.lists.operate_en;
            var strs1 = str1.split("\n");
            this.strs1 = strs1;

            var str2 = res.data.data.lists.management_en;
            var strs2 = str2.split("\n");
            this.strs2 = strs2;

            var str3 = res.data.data.lists.source_en;
            var strs3 = str3.split("\n");
            this.strs3 = strs3;

            var str4 = res.data.data.lists.logistics_en;
            var strs4 = str4.split("\n");
            this.strs4 = strs4;
          }
        }
      })
      .catch(function(error) {
        //  console.log(error);
      });
  }
};
</script>
<style scoped>
body {
  position: relative;
}
.banner {
  overflow: hidden !important;
  position: relative;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  width: 100%;
  height: 10.28rem;
}
.service {
  background: white;
  padding: 0.9rem 0.4rem 0;
}
.service1,
.service2,
.service3,
.service4 {
  margin: 0 auto 30px;
  /* display: flex; */
}
.service1r {
  width: 100%;
}
.service1r1 {
  height: 3.82rem;
}
.service1r2 {
  height: 4.18rem;
}
.service1r3 {
  height: 2.8rem;
}
.service1r4 {
  height: 4.2rem;
}
.service1r img {
  width: 100%;
  height: 100%;
}
.servicep {
  font-size: 0.48rem;
  line-height: 0.48rem;
  border-left: 0.05rem solid #76c3a2;
  padding-left: 10px;
  font-weight: bold;
  margin: 0 0 0.6rem 0;
}
.servicesp1,
.servicesp2 {
  color: grey;
  font-size: 0.24rem;
  line-height: 0.44rem;
  width: 100%;
}
.servicesp1 {
  margin: 0 0 0.36rem 0;
}

.bannerp1 {
  /* position: absolute;
  top: 230px;
  left: 400px; */
  text-align: center;
  font-size: 0.65rem;
  font-weight: bold;
  color: white;
  margin-top: 2rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/mbPages/mChildren.vue